import BackendService from 'BackendService';
import { useEffect, useState } from 'react';
import Contact from '../../../models/Contact';
import FundOpportunity from '../../../models/FundOpportunity';
import Investor from '../../../models/Investor';

export default function useContactOpportunitiesData(contactId: string | undefined) {
  const [contact, setContact] = useState<Contact | null>(null);
  const [contactLoading, setContactLoading] = useState(true);
  const [contactError, setContactError] = useState<string | undefined>();

  const [investments, setInvestments] = useState<Investor[]>([]);
  const [investmentsLoading, setInvestmentsLoading] = useState(true);

  const [availableFunds, setAvailableFunds] = useState<FundOpportunity[]>([]);
  const [fundsLoading, setFundsLoading] = useState(true);

  useEffect(() => {
    if (!contactId) return;
    setContactLoading(true);
    new BackendService()
      .getContact(contactId)
      .then(setContact)
      .catch((e) => setContactError(e?.message ?? 'Failed to load contact'))
      .finally(() => setContactLoading(false));
  }, [contactId]);

  useEffect(() => {
    if (!contactId) return;
    setInvestmentsLoading(true);
    new BackendService()
      .getContactInvestments(contactId)
      .then((data) => setInvestments(data ?? []))
      .catch(console.error)
      .finally(() => setInvestmentsLoading(false));
  }, [contactId]);

  useEffect(() => {
    setFundsLoading(true);
    new BackendService()
      .getFundOpportunityByStatus(['EOI', 'APPLICATION_OPEN'])
      .then((funds) => setAvailableFunds(funds ?? []))
      .catch(console.error)
      .finally(() => setFundsLoading(false));
  }, []);

  return {
    contact,
    contactLoading,
    contactError,
    investments,
    investmentsLoading,
    availableFunds,
    fundsLoading,
  };
}
